
import React, { useState, useEffect, useRef } from "react";

// import {
//   useSearchParams
// } from 'react-router-dom'

import cn from "classnames";
import { Link } from "react-router-dom";

import styles from "./Reset.module.scss";
import AuthService from "services/auth.service";
import { FiEye, FiEyeOff } from "react-icons/fi";
import LocalStorageService from "services/tokenlocalstorage.service";
import { useHistory } from "react-router-dom";
import cryptoJS from "crypto-js";
import notificationService from "services/notification.service";
export default function Signin(props) {
  const history = useHistory();
  const secretKey = "BSSSecretForRIL";

  // const [searchParams, setSearchParams] = useSearchParams();
  const [email, setEmail] = useState();
  const [formErrors, setFormErrors] = useState("");
  // const [searchParams, setSearchParams] = useParams();
  const [password, setPassword] = useState();
  const [remember, setRemember] = useState();
  const [error, setError] = useState();
  const [confirmPassword, setConfirmPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPswd, setConfirmPswd] = useState("password");
  const [newPswd, setNewPswd] = useState("password");
  const [otpView, setOTPView] = useState("password");
  const [otp, setOtp] = useState();
  // let { token } = useParams();

  const toggleOTP = () => {
    if (otpView === "password") {
      setOTPView("text");
      return;
    }
    setOTPView("password");
  };

  const togglePassword = () => {
    if (newPswd === "password") {
      setNewPswd("text");
      return;
    }
    setNewPswd("password");
  };

  const togglePasswords = () => {
    if (confirmPswd === "password") {
      setConfirmPswd("text");
      return;
    }
    setConfirmPswd("password");
  };

  const handleOTP = (e) => {
    setOtp(e.target.value);
  };

  const handlePassword = (e) => {
    if(e.target.value.length<=16)
    setNewPassword(e.target.value);
  };

  const handleConfirmPassword = (e) => {
    if(e.target.value.length<=16)
    setConfirmPassword(e.target.value);
  };

  const handleRemember = (e) => {
    setRemember(e.target.checked);
  };

  const keyboardEvents = (e) => {
    if (e.code == "Enter") {
      signin();
    }
  };

  const validate = () => {
    const regex = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,16}$');
    const error = {};
    let flag = true
    if (!otp) {
      error.otpError = "Please enter mandatory fields";
      flag = false;
    }
    if (!newPassword) {
      error.newPasswordError = "Please enter New Password"
      flag = false;
    }else if (!regex.test(newPassword)) {
      error.newPasswordError = "Password should be 8-16 characters in length containing atleast one uppercase letter, one lowercase letter, atleast one number and atleast one special character";
      flag = false;
    }
    if (!confirmPassword) {
      error.confirmPasswordError = ("Please enter confirm new password");
      flag = false;
    }
    if (newPassword &&  confirmPassword && newPassword !== confirmPassword) {
      setError("The new password should match confirm password");
      flag = false;
    }

    setFormErrors(error)
    return flag;
  };

  const signin = async () => {
    // const [searchParams, setSearchParams] = useSearchParams();

    // searchParams.get("token")

    // console.log(searchParams,"searchParams");

    /*const search = props.location.search;
    const serialId = new URLSearchParams(search).get('token');*/
   
    if(validate()){
      const serialId = props.location.search.split("?token=")[1];
      const encodedNewPassword = encodeURIComponent(newPassword);
    if (encodedNewPassword) {
      AuthService.resetPassword(encodedNewPassword, serialId, otp).then(
        (response) => {
          if (response?.data) {
            notificationService.showNonBlacklisted(
              response?.config?.url,
              response?.data?.message
            );
            // response(
            //   response?.data?.message
            //     ? response.data.message
            //     : "Failed to reset the password, Please retry"
            // );

            // history.push("/");
            // window.location.reload();
            // return;
          }
          setTimeout(() => {
            history.push("/");
            window.location.reload();
          }, 5000);
          // console.log("history",history)
        },
        (error) => {
          setError(
            error?.response?.data?.message
              ? error.response.data.message
              : "Failed to reset the password, Please retry"
          );
          return;
        }
      );
    }
    }
    
  };

  return (
    <div
      className={`Signin ${cn(styles.block, styles.block_layout, styles.signin_container)}`}
      style={{
        backgroundImage: `url(${require("assets/loginBackgrnd.png").default})`,
      }}
    >
      <div className={cn(styles.cover_block1, styles.cover_block1_layout)}>
        <div className={cn(styles.flex, styles.flex_layout)}>
          <div className={cn(styles.flex1, styles.flex1_layout)}>
            <div className={cn(styles.flex1_item)}>
              <div
                style={{
                  "--src": `url(${require("assets/jio-logo.png").default})`,
                }}
                className={cn(styles.icon, styles.icon_layout)}
              />
            </div>
            <div className={cn(styles.flex1_spacer)} />
            <h1 className={cn(styles.hero_title, styles.hero_title_layout)}>
              &nbsp;{"SwapUp"}
            </h1>
          </div>

          <h1 className={cn(styles.hero_title1, styles.hero_title1_layout)}>
            {"Reset Password"}
          </h1>
          <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
            {"OTP*"}
          </h2>
          <div className={cn(styles.box2)}>
          <input
             type={otpView === "password" ? "password" : "text"}
            name="otp"
            className={cn(styles.box1, styles.box1_layout)}
            required
            value={otp}
            onChange={handleOTP}
            placeholder={"Please enter Your OTP"}
          />
          <div className={cn(styles.eye_box)} onClick={toggleOTP}>
              {otpView !== "password" ? <FiEye /> : <FiEyeOff />}
            </div>
          </div>
          <p>{formErrors.otpError}</p>

          <h2 className={cn(styles.medium_title, styles.medium_title_layout1)}>
            {"New Password*"}
          </h2>
          <div className={cn(styles.box2)}>
            <input
              type={newPswd === "password" ? "password" : "text"}
              name="password"
              className={cn(styles.box1, styles.box1_layout)}
              required
              value={newPassword}
              onChange={handlePassword}
              placeholder={"Please enter your password"}
              color="#8E8E8E"
              autoComplete="off"
            />
            <div className={cn(styles.eye_box)} onClick={togglePassword}>
              {newPswd !== "password" ? <FiEye /> : <FiEyeOff />}
            </div>
          </div>
          <p>{formErrors.newPasswordError}</p>

          <h2 className={cn(styles.medium_title, styles.medium_title_layout1)}>
            {" Confirm Password*"}
          </h2>
          <div className={cn(styles.box2)}>
            <input
              type={confirmPswd === "password" ? "password" : "text"}
              name="confirmPassword"
              className={cn(styles.box1, styles.box1_layout)}
              required
              value={confirmPassword}
              onChange={handleConfirmPassword}
              placeholder={"Please confirm your new password"}
            />
            <div className={cn(styles.eye_box)} onClick={togglePasswords}>
              {confirmPswd !== "password" ? <FiEye /> : <FiEyeOff />}
            </div>
          </div>
          <p>{formErrors.confirmPasswordError}</p>

          <div className={cn(styles.flex2, styles.flex2_layout)}>
            {/* <div className={cn(styles.flex2_item)}>
              <input
                                type="checkbox"
                                name="remember"
                                className={cn(styles.box4, styles.box4_layout)}
                                required
                                checked={remember}
                                onChange={handleRemember}
      
                              />

            </div> */}
            <div className={cn(styles.flex2_spacer)} />
            {/* <div className={cn(styles.text_body1, styles.text_body1_layout)}>
              {'Keep me Signed in'}
            </div> */}
            <div className={cn(styles.flex2_spacer1)} />
            <Link to="/">
              <div className={cn(styles.text_body, styles.text_body_layout)}>
                {"Back To Sign In"}
              </div>
            </Link>
          </div>
          <div className={cn(styles.flex1_spacer)} />
          <div
            className={cn(styles.cover_block, styles.cover_block_layout)}
            onClick={signin}
          >
            <h2
              className={cn(styles.medium_title1, styles.medium_title1_layout)}
            >
              {"Submit"}
            </h2>
          </div>
          {error && (
            <p style={{ textAlign: "center", marginBottom: "20px" }}>{error}</p>
          )}
        </div>
      </div>
    </div>
  );
}

Signin.inStorybook = true;
